import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

const TICK_INTERVAL_MS = 50;

interface StoryProgressProps {
  total: number;
  current: number;
  duration: number;
  isPaused: boolean;
  onComplete: () => void;
}

export function StoryProgress({
  total,
  current,
  duration,
  isPaused,
  onComplete,
}: StoryProgressProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(0);
  }, [current]);

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 100 / (duration / TICK_INTERVAL_MS);
        if (next >= 100) {
          clearInterval(interval);
          onComplete();
          return 100;
        }
        return next;
      });
    }, TICK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [duration, isPaused, onComplete, current]);

  return (
    <div className="flex w-full gap-1 px-2 pt-3">
      {Array.from({ length: total }).map((_, index) => (
        <div key={index} className="h-0.5 flex-1 overflow-hidden rounded-full bg-white/30">
          <div
            className={cn(
              "h-full rounded-full bg-white transition-all",
              index < current && "w-full",
              index > current && "w-0"
            )}
            style={{
              width: index === current ? `${progress}%` : undefined,
              transition: index === current ? "none" : undefined,
            }}
          />
        </div>
      ))}
    </div>
  );
}
